import {
  Box,
  CircularProgress,
  Typography,
  makeStyles,
} from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import { useQuery } from 'react-query'

import Api from 'api'
import { mapCategoryToColor } from 'components/Categories/categories'
import { useLanguageContext } from 'components/LanguageContext'
import parseHtml from 'components/parseHtml'
import Tip from 'components/Tip'
import { useTipFilter } from 'components/TipFilterContext'

const useStyles = makeStyles(() => ({
  innerContainer: {
    height: '100%',
    overflowY: 'auto',
  },
  innerContainerLoading: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noTips: {
    margin: 20,
  },
}))

export default function Top10Tips() {
  const { i18n } = useLanguageContext()
  const { selectedCategory } = useTipFilter()

  const { isLoading, data } = useQuery({
    queryKey: ['top10tips', selectedCategory?.id],
    queryFn: () => Api.getTop10Tips({ categoryId: selectedCategory.id }),
  })

  const classes = useStyles()

  const tips = React.useMemo(() => data?.tips ?? [], [data])

  const renderTips = React.useCallback(() => {
    if (isLoading) {
      return null
    }

    if (tips.length === 0) {
      return (
        <Typography
          variant="subtitle2"
          color="textPrimary"
          className={classes.noTips}
        >
          {parseHtml(i18n.search.noTipsFound)}
        </Typography>
      )
    }

    return tips.map((tip, index) => (
      <Tip
        key={tip.id}
        id={`top10tip_${index}`}
        color={mapCategoryToColor[tip.category.parentId]}
        showDivider={index < tips.length - 1}
        tip={tip}
      />
    ))
  }, [isLoading, tips, classes, i18n])

  return (
    <Box
      id="top10-container"
      className={clsx({
        [classes.innerContainer]: true,
        [classes.innerContainerLoading]: isLoading,
      })}
    >
      {renderTips()}
      {isLoading && <CircularProgress />}
    </Box>
  )
}
